import ReactCodeInput from "react-code-input";
import Fillingnumber from "../../components/filling-number";

function Otp(params) {
  return (
    <Fillingnumber/>
  );
}

export default Otp;